<script setup lang="ts">
import { useAuth0 } from '@auth0/auth0-vue';
import { ClientOnly } from '@vuepress/client';
import { Button } from 'primevue';
const { user, loginWithRedirect, logout } = useAuth0() || {user:null, loginWithRedirect: null, logout: null};

function loginHandler() {
    loginWithRedirect();
}

function logoutHandler() {
    logout({
        logoutParams: {
            returnTo: window.location.origin+__VUEPRESS_BASE__
        }
    });
}
</script>

<template>
    <ClientOnly>
        <div v-if="!user">
            <p>Die funtrade Dokumentation steht nur angemeldeten Kundinnenn und Kunden zur Verfügung.</p>
            <p>Falls du bereits ein Login auf <strong>support.funtrade.ch</strong> hast, melde dich mit deinem Login
                an.<br />Falls nicht, registriere dich auf <a href="https://support.funtrade.ch">support.funtrade.ch</a>.
            </p>

            <Button severity="secondary" @click.prevent="loginHandler">
                Anmelden
            </Button>
        </div>
        <div v-else>
            <p>Eingeloggt als: <strong>{{ user.name }}</strong>
                <br />Email: <strong>{{ user.email }}</strong>
            </p>
            <Button @click.prevent="logoutHandler">Abmelden</Button>
        </div>
    </ClientOnly>
</template>

<style></style>
